import React, { FC } from 'react';
import styled from 'styled-components';

const StyledSeoLinks = styled.div`
    display: none;
`;

interface LooksSeoLinksProps {
    path: string;
    total: number;
    perPage: number | undefined;
}

const LooksSeoLinks: FC<LooksSeoLinksProps> = ({ path, total, perPage }) => {
    if (!perPage) {
        return <></>;
    }

    const pages = [...Array(Math.ceil(total / perPage))].map((_, i) => i + 1);
    return (
        <StyledSeoLinks>
            {pages.map(page => (
                <a key={page} href={page === 1 ? path : `${path}?page=${page}`}>
                    Looks Page {page}
                </a>
            ))}
        </StyledSeoLinks>
    );
};

export default LooksSeoLinks;
